import * as M from "./mutations";
import actions from "./actions";

import { createStore } from 'vuex'

export const mutations = {
  [M.SET_AUTH](state, payload) {
    state.isAuthed = true;
    state.token = payload.token;
    state.channelId = payload.channelId;
    state.userId = payload.userId;
  },
  [M.SET_RELEASE_STATE](state, releaseState) {
    state.releaseState = releaseState;
    switch (releaseState) {
      case "released":
        state.apiId = process.env.VUE_APP_ROOT_API_PROD_ID;
        break;
      default:
        state.apiId = process.env.VUE_APP_ROOT_API_STAGING_ID;
        break;
    }
  }
};

const store = new createStore({
  state: {
    isAuthed: false,
    token: null,
    channelId: -1,
    userId: -1,
    releaseState: "",
    apiId: ""
  },
  actions,
  mutations,
  getters: {
    getReleasedState: (state) => () =>{
      return state.releaseState;
    }
  }
});

export default store;
